// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"FormLabel_formLabel_23Xne","small":"FormLabel_small_1kFu6"};